import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const addNewUsersToRole = (
  language: string,
  userIds: number[],
  roleId: number,
  successCallback?: Function,
  finalCallback?: Function
) => {
  ApiService.post("users/roles/batch", { user_ids: userIds, role_id_or_name: String(roleId) })
    .then(() => {
      alert(translate(language, "PAGES.PERMISSIONS.MODALS.ADD_USERS_TO_ROLE.ALERTS.SUCCESS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error adding user to role", error);
      alert(translate(language, "PAGES.PERMISSIONS.MODALS.ADD_USERS_TO_ROLE.ALERTS.FAILED"));
    })
    .finally(() => finalCallback?.());
};
